<template>
  <component
    :is="wrapperTag"
    v-bind="wrapperAttrs"
    class="image relative"
    :class="{ 'cursor-pointer': isDownload }"
    @click="onClick"
  >
    <img
      class="block h-auto w-full object-cover"
      :style="{ aspectRatio: aspectRatio }"
      :src="attrs.image.src"
      :alt="attrs.image.alt || ''"
      :title="attrs.image.title || ''"
    />
    <div
      v-if="attrs.image.caption"
      class="fill-available absolute bottom-0 h-max bg-black/30 py-2 text-center text-sm text-white"
    >
      {{ attrs.image.caption }}
    </div>
  </component>
</template>

<script setup lang="ts">
import type { NodeProps } from './RenderNode.vue';
import { computed } from 'vue';
import { downloadFile } from '@/lib/download';
import { getImageAttrs } from '@modules/Post/TipTap/extensions/Image/ImageExtension';

const props = defineProps<NodeProps>();
const attrs = computed(() => getImageAttrs(props.node.attrs));
const isDownload = computed(() => attrs.value.type === 'download');
const wrapperTag = computed(() => (attrs.value.href ? 'a' : 'div'));
const wrapperAttrs = computed(() =>
  isDownload.value ? {} : { href: attrs.value.href, target: '_blank', rel: 'noopener' },
);

function onClick() {
  if (isDownload.value && attrs.value.href) {
    downloadFile(attrs.value.href);
    props.addTelemetry?.('download');
  }
}
const aspectRatio = computed(() => {
  const aspectRatio = attrs.value.aspectRatio;

  if (!aspectRatio) {
    return 'auto';
  }

  const roundedRatio = Math.round(aspectRatio * 100) / 100;

  const ratioMap: Record<number, string> = {
    1: '1 / 1',
    1.78: '16 / 9',
    0.75: '3 / 4',
    1.33: '4 / 3',
    2.39: '21 / 9',
    0.56: '9 / 16',
  };

  return ratioMap[roundedRatio] || `${aspectRatio} / 1`;
});
</script>

<style>
.fill-available {
  width: -webkit-fill-available;
}
</style>
